// Environment configuration for frontend

const isProd = import.meta.env.PROD;

export const config = {
  apiUrl:
    import.meta.env.VITE_API_URL ||
    (isProd ? "https://api.expedient.one" : "http://localhost:4000"),
  hasuraUrl:
    import.meta.env.VITE_HASURA_URL ||
    "https://hasura.expedient.one/v1/graphql",
  hasuraWsUrl:
    import.meta.env.VITE_HASURA_WS_URL ||
    "wss://hasura.expedient.one/v1/graphql",
  // NestJS GraphQL endpoint (for energy/weather queries)
  nestjsGraphqlUrl:
    import.meta.env.VITE_NESTJS_GRAPHQL_URL ||
    (isProd ? "https://api.expedient.one/api/graphql" : "http://localhost:4000/api/graphql"),
  // Hasura GraphQL endpoint (for tasks/companies queries)
  graphqlEndpoint:
    import.meta.env.VITE_APP_GRAPHQL_ENDPOINT ||
    "https://hasura.expedient.one/v1/graphql",
  isProd: isProd,
  isDev: !isProd,

  // --- LIVE KEYS (ACTIVE) ---
  stripe: {
    publishableKey:
      import.meta.env.VITE_STRIPE_PUBLIC_KEY ||
      "pk_live_51PnYppP5Tgc3ygfKKjiX9Qq1Qq", // Fallback for safety
    basicPriceId: "price_1SPqV8P5Tgc3ygfKCc05hkDZ", // Starter Monthly $29
    basicYearlyPriceId: "price_1SPqXMP5Tgc3ygfKpiwdUHdv", // Starter Yearly $299
    premiumPriceId: "price_1SPqVpP5Tgc3ygfKsLIgCF7v", // Professional Monthly $79
    premiumYearlyPriceId: "price_1SPqX2P5Tgc3ygfKRvip2DDp", // Professional Yearly $799
  },

  // --- TEST KEYS (COMMENTED OUT) ---
  // stripe: {
  //   publishableKey: "pk_test_51PnYppP5Tgc3ygfKLDaqU5GJ3AlQFc7sIvrq35F321PWQxCS7sfX7tHZEX53kvVYQXoTVkFzYkZgS5QPxAqaxjtH00xUC1RnIp",
  //   basicPriceId: "price_1RjU9fP5Tgc3ygfKaTp5XhDg",
  //   basicYearlyPriceId: "price_1RjUAWP5Tgc3ygfKy5MoTjWj",
  //   premiumPriceId: "price_1RjUAAP5Tgc3ygfK4ynLqoAV",
  //   premiumYearlyPriceId: "price_1RjUArP5Tgc3ygfKce9G4jmE",
  // },

  // API Configuration - Fixed production URLs
  api: {
    production: {
      baseUrl: "https://app.expedient.one",
      backendUrl: "https://api.expedient.one",
    },
    development: {
      baseUrl: "http://localhost:3000",
      backendUrl: "http://localhost:4000",
    },
  },

  // Frontend Configuration
  frontend: {
    url: import.meta.env.VITE_FRONTEND_URL || "https://app.expedient.one",
  },

  // Default locations
  defaultLocation: {
    lat: 40.7128,
    lng: -74.006,
  },

  // Google Maps API Key (for frontend map features)
  googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',
};

// Debug logging
console.log("🔧 ENV DEBUG:", {
  VITE_API_URL: import.meta.env.VITE_API_URL,
  DEV: import.meta.env.DEV,
  PROD: import.meta.env.PROD,
  finalApiUrl: config.apiUrl,
});

export default config;
